module.exports = require("angular2-useful-swiper");